export interface DataCollection {
	identitykitId: string;
	answers: Answer[];
	lastQuestion: string;
	userLevel: number;
}

interface Answer {
	question: string;
	answer01?: string;
	answer02?: string;
	answer03?: string;
	answer04?: string;
	answer05?: string;
	answer06?: string;
	answer07?: string;
	answer08?: string;
	answer09?: string;
	questionLevel: number;
}

export enum CtaType {
	RADIO = 'RADIO',
	CHECKBOX = 'CHECKBOX',
	SELECT = 'SELECT',
	INPUT = 'INPUT',
}
